export default function GS_Format_Fonts() {
  return (
    <div className="p-4">
      <h1>GS Format Fonts</h1>
    </div>
  );
}
